import { cn } from '@/lib/utils';
import type { RunStatus } from '@/entities/sender.entity';

export type SenderChipTone = 'primary' | 'success' | 'destructive' | 'muted' | 'warning';

export function runStatusToChipTone(status: RunStatus | string): SenderChipTone {
	switch (status) {
		case 'running':
			return 'primary';
		case 'completed':
		case 'completed_empty':
			return 'success';
		case 'failed':
			return 'destructive';
		case 'queued':
			return 'muted';
		case 'completed_with_warnings':
			return 'warning';
		default:
			return 'muted';
	}
}

const TONE_CLASS: Record<SenderChipTone, string> = {
	primary: 'bg-primary/15 text-primary',
	success: 'bg-chart-2/15 text-chart-2',
	destructive: 'bg-destructive/15 text-destructive',
	muted: 'bg-muted text-muted-foreground',
	warning: 'bg-chart-4/15 text-chart-4',
};

interface SenderStatusChipProps {
	label: string;
	tone?: SenderChipTone;
	className?: string;
}

export default function SenderStatusChip({ label, tone = 'muted', className }: SenderStatusChipProps) {
	return (
		<span
			className={cn(
				'inline-flex max-w-full items-center rounded-full px-2.5 py-0.5 text-[13px] font-medium',
				TONE_CLASS[tone],
				className,
			)}
		>
			{label}
		</span>
	);
}
